import React from "react";

import { CircularProgress, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { BsInfoCircle } from "react-icons/bs";
import { GoPlusCircle } from "react-icons/go";

import { Booking } from "../../../../../../models/booking";
import { CartonView } from "../../../../../../models/carton";
import { ShipmentType } from "../../../../../../util/enums";
import ShipmentTooltip from "../../../../../Shipments/Maintenance/components/ShipmentTooltips";
import { DefaultTooltip } from "../../../../Tooltip";
import useStyles from "./styles";

interface Props {
  carton?: CartonView;
  show?: boolean;
  loadingProducts?: boolean;
  booking?: Booking;
  addProductIntoCarton: (sscc?: string, orderToFilter?: string) => void;
  isCalledFromBooking?: boolean;
}

const AddProductButton = (props: Props) => {
  const { carton, show, booking, loadingProducts, addProductIntoCarton, isCalledFromBooking } =
    props;

  const { t: translate } = useTranslation();
  const classes = useStyles();

  if (carton?.isClosed || !show) return null;

  const renderTitle = () => (
    <div className={classes.tooltipContainer}>
      {!booking?.shipmentType && (
        <div className={classes.tooltipTitle}>
          <BsInfoCircle />
          <span>{translate("youMustSelectABookingModeFirst")}</span>
        </div>
      )}
      {!booking?.portOfLoadingId && (
        <div className={classes.tooltipTitle}>
          <BsInfoCircle />
          <span>{translate("youMustSelectABookingLoadingPortFirst")}</span>
        </div>
      )}
      {!booking?.portOfDischargeId && (
        <div className={classes.tooltipTitle}>
          <BsInfoCircle />
          <span>{translate("youMustSelectABookingDischargePortFirst")}</span>
        </div>
      )}
      {!booking?.cargoReadyDate && (
        <div className={classes.tooltipTitle}>
          <BsInfoCircle />
          <span>{translate("youMustSelectedABookingCargoReadyDateFirst")}</span>
        </div>
      )}
    </div>
  );
  const tooltip = () => {
    if (!booking?.isBooking && !isCalledFromBooking) {
      return <ShipmentTooltip />;
    }

    return renderTitle();
  };
  const disabledButtonBooking: boolean =
    !!booking &&
    (!booking?.shipmentType ||
      !booking.portOfDischargeId ||
      !booking.portOfLoadingId ||
      !booking.cargoReadyDate);

  const disableByMode = () => {
    if (booking?.shipmentType === ShipmentType.AIR || booking?.shipmentType === ShipmentType.SEA) {
      return !booking?.portOfLoadingId || !booking?.portOfDischargeId;
    }

    return !booking?.destination || !booking?.origin;
  };

  const disabledButtonShipment: boolean =
    !!booking && (!booking?.shipmentType || disableByMode() || !booking?.incoterm);

  const disabledButton = isCalledFromBooking ? disabledButtonBooking : disabledButtonShipment;

  if (loadingProducts) {
    return (
      <Grid item data-cy="add-product-loading" className={classes.loadingButton}>
        <CircularProgress size={18} />
      </Grid>
    );
  }

  return (
    <DefaultTooltip title={disabledButton ? tooltip() : translate("addProducts")}>
      <div
        onClick={
          disabledButton
            ? undefined
            : () => addProductIntoCarton(carton?.sscc, carton?.products?.[0]?.poNumber)
        }
      >
        <Grid item data-cy="add-product" className={classes.actionButton}>
          <GoPlusCircle size={18} color="#475467" />
        </Grid>
      </div>
    </DefaultTooltip>
  );
};

export default AddProductButton;
